import api from '@/services/api';
import { mapActions } from 'vuex';

export default {
    props: ['name', 'bnr', 'amount', 'minimum', 'id', 'type', 'image'],

    data() {
        return {
            productAmount: null,
        };
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),

        updateProductCount() {
            const params = new URLSearchParams();
            if(this.type === 'product') {
                params.append('counted_stock', this.amount);
                // /api/promotion_gifts/ ZA GIFTOVE
                api.post(`/api/promotion_product/${this.id}/change_stock`, params)
                    .then((response) => {
                        if(response.data.message === 'EUCERIN_PROMOTION_PRODUCT_STOCK_CHANGED') {
                            this.storePromotion();
                        }
                        this.$emit('close-modal')
                    })
                    .catch((error) => {
                        //commit('SHOW_LOGIN_ERRORS', error.response.data);
                    });
                return '';
            }

            params.append('counted_stock', this.amount);
            // /api/promotion_gifts/ ZA GIFTOVE
            api.post(`/api/promotion_gift/${this.id}/change_stock`, params)
                .then((response) => {
                    this.storePromotion();
                    this.$emit('close-modal')
                })
                .catch((error) => {
                    //commit('SHOW_LOGIN_ERRORS', error.response.data);
                });

        },
    },

    mounted () {
        this.$refs.count.focus();
        this.$refs.count.select();
    },
}